import { faStar as faStarLight } from '@fortawesome/pro-light-svg-icons';
import { faStar as faStarSolid } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GroupPictureRole } from '@kcftech/prometheus-client';
import { useMutation } from '@tanstack/react-query';
import { ActionMenuItem } from 'components/menu/ActionMenuItem';
import { sdClient } from 'contexts/SDKClientContext';
import { tokens } from 'styles/tokens';

import type { FileActionsBase, FileIsh } from './base';

function isPrimaryImage(file: FileIsh) {
    const ctx = file.groupContext;
    if (!ctx) {
        throw new Error('group context was not initialized');
    }
    if ('IsPrimaryImage' in file) {
        return ctx.IsPrimaryImage;
    }
    if ('Role' in file) {
        return ctx.Role === GroupPictureRole.Overview;
    }
}

function useMakePrimaryMutation(base: FileActionsBase) {
    return useMutation(
        base.actionMutationOptions({
            mutationFn: async (picture: FileIsh) => {
                if (picture.EntryType !== 'Folder' && base.group) {
                    await sdClient.setPrimaryImageForGroup({
                        groupId: base.group.Id,
                        body: picture.Id,
                    });
                }
            },
            errorMessage: 'Unable to set primary image.',
            onSuccess: () => base.onChange(),
        }),
    );
}

function MakePrimaryMenuItem({
    base,
    mutate,
}: {
    base: FileActionsBase;
    mutate: (file: FileIsh) => void;
}) {
    if (!base.hasGroupActions) {
        return null;
    }
    const isPrimary = isPrimaryImage(base.rowData);

    return (
        <ActionMenuItem
            title="Make Primary Image"
            disabled={isPrimary}
            hoverIcon={
                <FontAwesomeIcon icon={faStarSolid} color={tokens.misc.favorite} />
            }
            icon={
                <FontAwesomeIcon
                    icon={isPrimary ? faStarSolid : faStarLight}
                    color={tokens.misc.favorite}
                />
            }
            onSelect={() => mutate(base.rowData)}
        />
    );
}

export const MakePrimary = {
    useMutation: useMakePrimaryMutation,
    MenuItem: MakePrimaryMenuItem,
};
